// Markdown for text people type into the app, such as suggestion descriptions.
// The input is HTML-escaped before any markup is added, so nothing typed can
// become a tag; the <Markdown> component runs DOMPurify over it as well.
// ponytail: headings, bold, italics, inline code, links, flat lists, rules and
// paragraphs only. No tables, nested lists or fenced code; swap in `marked` if
// those start turning up.

const esc = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

const inline = (s) => esc(s)
  .replace(/`([^`]+)`/g, '<code>$1</code>')
  .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
  .replace(/(^|[^*])\*([^*\s][^*]*?)\*(?!\*)/g, '$1<em>$2</em>')
  .replace(/\[([^\]]+)\]\(((?:https?:\/\/|mailto:)[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

export function renderMarkdown(text) {
  const out = [];
  let para = [];
  let list = null;
  const flushPara = () => { if (para.length) out.push(`<p>${para.map(inline).join('<br>')}</p>`); para = []; };
  const flushList = () => { if (list) out.push(`<${list.tag}>${list.items.map(i => `<li>${inline(i)}</li>`).join('')}</${list.tag}>`); list = null; };
  const flush = () => { flushPara(); flushList(); };

  for (const line of String(text || '').split(/\r?\n/)) {
    const t = line.trim();
    let m;
    if (!t) flush();
    else if (/^(-{3,}|\*{3,}|_{3,})$/.test(t)) { flush(); out.push('<hr>'); }
    else if ((m = t.match(/^(#{1,6})\s+(.*)$/))) { flush(); out.push(`<h${m[1].length}>${inline(m[2])}</h${m[1].length}>`); }
    else if ((m = t.match(/^(?:([-*+])|\d+[.)])\s+(.*)$/))) {
      const tag = m[1] ? 'ul' : 'ol';
      flushPara();
      if (list?.tag !== tag) { flushList(); list = { tag, items: [] }; }
      list.items.push(m[2]);
    }
    else { flushList(); para.push(t); }
  }
  flush();
  return out.join('');
}
